import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APIFactoryEndPoints } from 'src/app/common/apifactory-end-points';
import { HandleError } from '../http-error-handler.service';
import { AbstractControl, FormArray, UntypedFormGroup } from '@angular/forms';
import { ScheduleNameSetUp } from 'src/app/model/FacilityManager/schedule-name-set-up';
import { Observable } from 'rxjs';
import { BookingNameSetup } from 'src/app/model/FacilityManager/booking-name-setup';
import { InventoryType } from 'src/app/model/FacilityManager/inventory-type';
import { ProductMatrix } from 'src/app/model/FacilityManager/product-matrix';
import { ProductGroup } from 'src/app/model/FacilityManager/product-group';
import { ProductSubGroup } from 'src/app/model/FacilityManager/product-sub-group';
import { ProductDetails } from 'src/app/model/FacilityManager/product-details';
import { FacilityManagerSetup } from 'src/app/model/FacilityManager/facility-manager-setup';

@Injectable({
  providedIn: 'root'
})
export class FacilitymanagerSetupService {


  constructor(
    private http: HttpClient,
    private apiURL: APIFactoryEndPoints,
  ) { }



  viewFacilityManagerByCompany(url: string, companyNo: number) {
    return this.http.get<FacilityManagerSetup>(url + '/' + companyNo)
  }




  saveName(url: string, form: AbstractControl) {


    return this.http.post<any>(
      url,
      form.value,
      { responseType: 'json' }

    );
  }



  deleteScheduleName(url: string, refNo: number): Observable<any> {
    return this.http.delete(url + '/' + refNo);
  }



  saveBookingName(Url: string, form: AbstractControl) {
    return this.http.post<any>(
      Url,
      form.value,
      { responseType: 'json' }

    );
  }



  deleteBookingName(url: string, refNo: number): Observable<any> {
    return this.http.delete(url + '/' + refNo);
  }



  getAllInventoryType() {
    return this.http.get<InventoryType[]>(this.apiURL.viewInventoryType);
  }


  getMatrixByInventory(url: string, inventoryCode: number) {
    return this.http.get<ProductMatrix[]>(url + '/' + inventoryCode)
  }


  getGroupByMatrix(url: string, inventoryCode: number) {
    return this.http.get<ProductGroup[]>(url + '/' + inventoryCode)
  }

  getSubGroupByGroup(url: string, groupId: number) {
    return this.http.get<ProductSubGroup[]>(url + '/' + groupId)
  }

  getProductBySubGroup(url: string, subGroupId: number) {
    return this.http.get<ProductDetails[]>(url + '/' + subGroupId)
  }


  insertMaterialsProduct(url: string, formArray: UntypedFormGroup) {
    return this.http.post(
      url, formArray.value
    );
  }

  insertMaterialsProductIndivisually(Url: string, form: AbstractControl) {
    return this.http.post(
      Url,
      form.value,
      { responseType: 'json' }

    );
  }


  deleteMaterialProduct(url: string, refNo: number): Observable<any> {
    return this.http.delete(url + '/' + refNo);
  }

}
